import React, { useEffect, useState, useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as marketActions from 'actions/gia_ca_thi_truong';
import * as locationActions from 'actions/location';
import { dislikeMarketPrice, likeMarketPrice } from 'redux/actions/gia_ca_thi_truong';

import AppContext from 'components/app_context';
import AddMetaTags from 'components/add_meta_tags';
import LeftSidebar from 'components/left_sidebar';
import SearchBox from './components/searchBox';
import MarketPriceItem from './components/marketPriceItem';
import Loader from 'components/loader';

import { toastErrorLogin } from 'helpers/toastHelper';
import { PAGE } from 'constants';
import useRewriteUrl from 'hooks/useRewriteUrl';
import _ from 'lodash';

function GiaCaThiTruongTheoMatHang(props) {
  useRewriteUrl();
  const dispatch = useDispatch();
  const { current_user, isMobile } = useContext(AppContext);
  const location = useLocation();
  const state = location.state;

  const [page, setPage] = useState(PAGE);
  const [keyword, setKeyword] = useState('');
  const [date, setDate] = useState(null);
  const [provinceId, setProvinceId] = useState(null);
  const [agriculturalType, setAgriculturalType] = useState('all');
  const [catalogueId, setCatalogueId] = useState(() => state?.catalogueId ?? null);
  const [reset, setReset] = useState(false);
  const catalogueName = state?.catalogueName || '';

  const { fetchAllMarketPrices, fetchLoadMoreMarketPrices } = props.marketActionsCreators;
  const { fetchProvince } = props.locationActionsCreator;
  const { data, isLoadMore, isLoading } = props.listMarketPrices;
  const { data: listProvinces } = props.listProvinces;

  const handleLikeMarketPrice = (isLike, marketPriceId) => {
    if (!current_user) {
      toastErrorLogin(isMobile);
      return;
    }

    const action = isLike ? dislikeMarketPrice : likeMarketPrice;
    dispatch(
      action({
        id: current_user.id,
        classable_type: 'MarketPlace',
        classable_id: marketPriceId,
      }),
    );
  };

  const handleLoadMore = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchLoadMoreMarketPrices({
      page: nextPage,
      agricultural_type: agriculturalType === 'all' ? '' : agriculturalType,
      market_place_catalogue_id: catalogueId,
    });
  };

  const searchMarketPrices = () => {
    fetchAllMarketPrices({
      keyword,
      province_id: provinceId,
      date,
      agricultural_type: agriculturalType === 'all' ? '' : agriculturalType,
      market_place_catalogue_id: catalogueId,
    });
  };

  const handleCancelSearch = () => {
    fetchProvince();
    setKeyword('');
    setDate(null);
    setProvinceId(null);
    fetchAllMarketPrices({
      page: 1,
      agricultural_type: agriculturalType === 'all' ? '' : agriculturalType,
      market_place_catalogue_id: catalogueId,
    });
    setPage(1);
  };

  const onClick = e => {
    if (!current_user) {
      e.preventDefault();
      toastErrorLogin(isMobile);
    }
  };

  useEffect(() => {
    fetchAllMarketPrices({
      page,
      agricultural_type: agriculturalType === 'all' ? '' : agriculturalType,
      market_place_catalogue_id: catalogueId,
    });
    fetchProvince();
  }, [agriculturalType]);

  if (listProvinces.filter(item => item.name === 'Tất cả').length === 0)
    listProvinces.unshift({ id: null, name: 'Tất cả' });
  const listProvincesFormatted = _.map(listProvinces, item => {
    return {
      value: item.id,
      label: item.name,
    };
  });
  return (
    <>
      <AddMetaTags title="Giá cả thị trường" />
      <div className="gctt-detail">
        <div className="gctt">
          <div className="row">
            <LeftSidebar isShoWidgetMarketPrice={false} />
            <div className="col-md-9 col-sm-12 mkt-price">
              <div className="d-flex align-items-center text-center">
                <div className="w-100 text-center">
                  <h4 className="text-uppercase fw-bold my-2">{catalogueName}</h4>
                </div>
                {current_user && (
                  <div className="d-flex justify-content-end">
                    <Link
                      to="/chuyen-muc/gia-ca-thi-truong/dong-gop"
                      className="btn btn-sm contribute ms-auto"
                      onClick={onClick}
                    >
                      <img src="/images/donggop_icon.png" alt="Đóng Góp" />
                      <span className="txt">Đóng góp</span>
                    </Link>
                  </div>
                )}
              </div>
              <SearchBox
                handleCancelSearch={handleCancelSearch}
                listProvinces={listProvincesFormatted}
                searchMarketPrices={searchMarketPrices}
                setKeyword={setKeyword}
                setProvinceId={setProvinceId}
                setCatalogueId={setCatalogueId}
                catalogueId={catalogueId}
                setDate={setDate}
                date={date}
                keyword={keyword}
                fetchMarketPricesByCatalogue={fetchAllMarketPrices}
                agriculturalType={agriculturalType}
                setReset={setReset}
                reset={reset}
                page="marketFilterCatalogue"
              />
              <div className="row row-cols-2 d-flex mt-3"></div>
              {isLoading && <Loader isLoading={isLoading} />}
              <div className="row g-3">
                <div className="row g-3 tab-content">
                  {data &&
                    data.map(market => {
                      const priceDifference = market?.get_market_price_last?.price_difference || 0;
                      return (
                        <div key={market?.id} className="col-sm-12 col-md-6">
                          <div className="card d-flex">
                            <div className="w-100">
                              <MarketPriceItem
                                market={market}
                                priceDifference={priceDifference}
                                handleLikeMarketPrice={handleLikeMarketPrice}
                              />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>

              {isLoadMore && (
                <div className="text-center my-3">
                  <button onClick={handleLoadMore} className="btn btn-primary">
                    Xem thêm
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = state => ({
  listMarketPrices: state.market.listMarketPrices,
  listProvinces: state.location.listProvinces,
  listFollowingMarketPrices: state.market.listFollowingMarketPrices,
});

const mapDispatchToProps = dispatch => ({
  marketActionsCreators: bindActionCreators(marketActions, dispatch),
  locationActionsCreator: bindActionCreators(locationActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(GiaCaThiTruongTheoMatHang);
